var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFeedbackModalDetailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.409 6.098l-3.766.627a.25.25 0 00-.193.16l-1.299 3.479c-.123.32.211.624.518.47l9-4.5a.375.375 0 000-.67l-9-4.5a.375.375 0 00-.518.471l1.3 3.479a.25.25 0 00.192.159L6.41 5.9a.1.1 0 010 .198h-.001z",
    fill: "#FF6C01"
  })));
}

export default SvgFeedbackModalDetailIcon;